import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTourData } from '../data/tour-data';
import { TourEvidencePanel, TourEvidenceStrengthBadge } from '../components/TourEvidencePanel';

export function TourMemoryPage() {
  const fixture = useTourData();
  const memory = fixture.machine_memory;
  const [claims, setClaims] = useState(memory.insights[0]?.evidence_claim_ids ?? []);
  const [title, setTitle] = useState('Evidence for this insight');

  return (
    <section className="r42-memory-page r42-tour-memory-page">
      <header className="r42-memory-head">
        <div><span className="r42-eyebrow">Machine intelligence</span><h1>Machine Memory</h1><p>What Route42 currently knows about {fixture.machine.machine_name}.</p></div>
        <div className="r42-memory-head-meta"><span className="r42-memory-status r42-memory-status--ready"><i className="bi bi-check-circle" /> Active</span><span className="r42-memory-version">Version {memory.memory_version}</span></div>
      </header>

      <div className="r42-tour-memory-layout">
        <main className="r42-memory-main">
          <section className="r42-memory-assessment" data-tour-target="machine-memory">
            <div className="r42-memory-section-head"><div><span className="r42-eyebrow">Current assessment</span><h2>What Route42 currently understands</h2></div></div>
            <p className="r42-memory-assessment-text">{memory.summary}</p>
            <div className="r42-memory-assessment-meta"><span><i className="bi bi-clock-history" /> Updated {new Date(memory.updated_at).toLocaleString()}</span></div>
          </section>

          <section className="r42-tour-memory-section">
            <div className="r42-tour-section-title"><div><span className="r42-eyebrow">Key insights</span><h2>Evidence-backed machine intelligence</h2></div><span>{memory.insights.length}</span></div>
            {memory.insights.map((item) => (
              <button key={item.insight_id} type="button" className="r42-tour-memory-row" onClick={() => { setClaims(item.evidence_claim_ids); setTitle(`Evidence for “${item.title}”`); }}>
                <div><strong>{item.title}</strong><p>{item.statement}</p></div><TourEvidenceStrengthBadge strength={item.evidence_strength} />
              </button>
            ))}
          </section>

          <section className="r42-tour-memory-section">
            <div className="r42-tour-section-title"><div><span className="r42-eyebrow">Observed relationship</span><h2>How evidence connects across time</h2></div></div>
            {memory.relationships.map((item) => (
              <button key={item.relationship_id} type="button" className="r42-tour-memory-row" onClick={() => { setClaims(item.evidence_claim_ids); setTitle(`Evidence for “${item.title}”`); }}>
                <div><strong>{item.title}</strong><p>{item.statement}</p></div><TourEvidenceStrengthBadge strength={item.evidence_strength} />
              </button>
            ))}
          </section>

          <section className="r42-tour-memory-section r42-tour-memory-section--gap">
            <div className="r42-tour-section-title"><div><span className="r42-eyebrow">Documentation gap</span><h2>What Route42 still needs</h2></div></div>
            {memory.documentation_gaps.map((gap) => <article key={gap.gap_id} className="r42-tour-gap-card"><i className="bi bi-question-circle" /><div><strong>{gap.statement}</strong><p>{gap.why_it_matters}</p></div></article>)}
          </section>

          <div className="r42-tour-next-card"><div><strong>Memory is persistent, but traceable.</strong><span>Activity shows how this understanding developed over time.</span></div><Link className="btn r42-btn-primary" to="/tour/activity">View Activity</Link></div>
        </main>

        <div>
          <TourEvidencePanel fixture={fixture} claimIds={claims} title={title} />
          <section className="r42-tour-ace-preview"><i className="bi bi-stars" /><div><span className="r42-eyebrow">{fixture.ace_example.title}</span><strong>{fixture.ace_example.prompt}</strong><p>{fixture.ace_example.answer}</p></div></section>
        </div>
      </div>
    </section>
  );
}
